import { APP_NAME, metafieldFields } from "../fields";
import { commonCustomerProductFields } from "../product-gql";

const wishListMetafieldName: Record<string, string> = {
  tune: '(namespace: "wish_list", key: "products")',
  yeseyesee: '(namespace: "info", key: "wishlist")',
  thisisneverthat: '(namespace: "info", key: "wishlist")',
  khakis: '(namespace: "info", key: "wishlist")',
  jknd: '(namespace: "info", key: "wishlist")',
};

export const wishListMetafield = {
  operation: {
    name: `metafield${wishListMetafieldName[APP_NAME]}`,
    alias: "wishlist",
  },
  fields: [
    ...metafieldFields,
    {
      operation: "references(first: 250)",
      fields: [
        {
          edges: [
            {
              node: [
                {
                  operation: "Product",
                  fields: commonCustomerProductFields,
                  fragment: true,
                },
              ],
            },
          ],
        },
      ],
      variables: {},
    },
  ],
  variables: {},
};

const genderMetafieldName: Record<string, string> = {
  tune: '(namespace: "custom", key: "gender")',
  yeseyesee: '(namespace: "info", key: "gender")',
  thisisneverthat: '(namespace: "info", key: "gender")',
  khakis: '(namespace: "info", key: "gender")',
  jknd: '(namespace: "info", key: "gender")',
};

export const genderMetafield = {
  operation: {
    name: `metafield${genderMetafieldName[APP_NAME]}`,
    alias: "gender",
  },
  fields: metafieldFields,
  variables: {},
};

const birthMetafieldName: Record<string, string> = {
  tune: '(namespace: "custom", key: "birth")',
  yeseyesee: '(namespace: "info", key: "birth")',
  thisisneverthat: '(namespace: "info", key: "birth")',
  khakis: '(namespace: "info", key: "birth")',
  jknd: '(namespace: "info", key: "birth")',
};

export const birthMetafield = {
  operation: {
    name: `metafield${birthMetafieldName[APP_NAME]}`,
    alias: "birth",
  },
  fields: metafieldFields,
  variables: {},
};

export const cardInfoMetafield = {
  operation: {
    name: 'metafield(namespace: "custom", key: "card_info")',
    alias: "cardInfo",
  },
  fields: metafieldFields,
  variables: {},
};

const excludeLimitName: Record<string, string> = {
  tune: '(namespace: "custom", key: "exclude_limit")',
  yeseyesee: '(namespace: "operation", key: "exclude_limit")',
  thisisneverthat: '(namespace: "operation", key: "exclude_limit")',
  khakis: '(namespace: "operation", key: "exclude_limit")',
  jknd: '(namespace: "operation", key: "exclude_limit")',
};

export const excludeLimitMetafield = {
  operation: {
    name: `metafield${excludeLimitName[APP_NAME]}`,
    alias: "exclude_limit",
  },
  fields: metafieldFields,
  variables: {},
};
